// imports
import { watchViewport } from 'tornis';
import { navigation } from './main-navigation';

let $html = document.querySelector('html'),
    $body = document.querySelector('body.site-layout'),
    buffer = 10,
    headerHidden = false,
    bodyHeight = 0,
    lastScrollY = 0,
    pageScrolledThreshold = 80,
    logoShrinkThreshold = 300,
    smartHeader = false,
    t;

const eventHeaderHide = new Event('headerHide'),
    eventHeaderShow = new Event('headerShow');

// scroll functions

const toggleHeader = (mode) => { // true = show, false = hide
    if (mode && headerHidden) {
        $html.classList.remove('header-hidden');
        headerHidden = false;
        window.dispatchEvent(eventHeaderShow);
    } else if (!mode && !headerHidden) {
        $html.classList.add('header-hidden');
        headerHidden = true;
        window.dispatchEvent(eventHeaderHide);
    }
};

// define a watched function, to be run on each update
const updateScroll = ({scroll, size}) => {
    if (size.changed || scroll.changed) {
        // page scrolled at all?
        $html.classList.toggle('page-scrolled', scroll.top > 0);
        // minimal header styling?
        $html.classList.toggle('minimal-header', scroll.top > logoShrinkThreshold);
        // do smart or minify header changes?
        if(smartHeader) {
            if (scroll.top > (lastScrollY + buffer) && scroll.top > pageScrolledThreshold && !navigation.active) {
                clearTimeout(t);
                t = setTimeout(toggleHeader(false), 200);
                lastScrollY = scroll.top;
            } else if (scroll.bottom < bodyHeight && (scroll.top < (lastScrollY - buffer) || scroll.top <= pageScrolledThreshold)) {
                clearTimeout(t);
                t = setTimeout(toggleHeader(true), 200);
                lastScrollY = scroll.top;
            }
        }
    }
}

// bind the watch function
watchViewport(updateScroll);

// also watch $body for resize caused by expanders etc.
const ro = new ResizeObserver(() => {
    bodyHeight = $body.offsetHeight;
});
ro.observe($body);